import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { PartnerComponent } from './pages/partner/partner.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { FaqComponent } from './pages/faq/faq.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { IslamicCommitteeComponent } from './pages/islamic-committee/islamic-committee.component';
import { BlogComponent } from './components/blogs/blog/blog.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ComplaintsComponent } from './pages/complaints/complaints.component';
import { FilePickerComponent } from './components/partner/file-picker/file-picker.component';
import { FormComponent } from './components/complaints/form/form.component';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { InterceptorsService } from './interceptors/main';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgxDatepickerModule } from '@handylib/ngx-datepicker';
import { EmailConfirmationOrExpiredComponent } from './pages/email-confirmation-or-expired/email-confirmation-or-expired.component';
import { LeadingZeroDirective } from './directives/leading-zero.directive';
import { ThreeStepsPartnerFormComponent } from './components/partner/three-steps-form/form.component';
import { PartnerFormComponent } from './components/partner/form/form.component';
import { ContactSupportComponent } from './components/partner/contact-support/contact-support.component';
import { ErrorPageNotFoundComponent } from './pages/error-page-not-found/error-page-not-found.component';
import { AllStepsInOnePartnerFormComponent } from './pages/be-partner-form-all-steps-in-one-form/be-partner-form-all-steps-in-one-form.component';
import { BePartnerRegistrationCompleted } from './components/partner/registration-completed/registration-completed.component';
import { FirstBlogComponent } from './components/blogs/first-blog/first-blog.component';
import { BlogPageComponent } from './pages/blogs/blog-page/blog-page.component';
import { CoverComponent } from './components/home/cover/cover.component';
import { CategoriesComponent } from './components/home/categories/categories.component';
import { FinancialStatementsComponent } from './pages/financial-statements/financial-statements.component';
import { NafathVerificationComponent } from './pages/nafath-verification/nafath-verification.component';
import { SuccessPopupComponent } from './components/nafath-verification/success-popup/success-popup.component';
import { NafathVerificationSucceededComponent } from './nafath-verification-succeeded/nafath-verification-succeeded.component';
import { MainPartnersComponent } from './components/home/main-partners/main-partners.component';
import { NgxPaginationModule } from 'ngx-pagination';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutUsComponent,
    PartnerComponent,
    BlogsComponent,
    FaqComponent,
    PrivacyComponent,
    TermsAndConditionsComponent,
    IslamicCommitteeComponent,
    BlogComponent,
    ComplaintsComponent,
    FilePickerComponent,
    FormComponent,
    LoaderComponent,
    EmailConfirmationOrExpiredComponent,
    LeadingZeroDirective,
    ThreeStepsPartnerFormComponent,
    PartnerFormComponent,
    ContactSupportComponent,
    ErrorPageNotFoundComponent,
    AllStepsInOnePartnerFormComponent,
    BePartnerRegistrationCompleted,
    FirstBlogComponent,
    BlogPageComponent,
    CoverComponent,
    CategoriesComponent,
    FinancialStatementsComponent,
    NafathVerificationComponent,
    SuccessPopupComponent,
    NafathVerificationSucceededComponent,
    MainPartnersComponent,
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    SelectDropDownModule,
    NgxDatepickerModule,
    NgxPaginationModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorsService, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
